import LoginIcon2 from "@mui/icons-material/Login";
import LogoutIcon2 from "@mui/icons-material/Logout";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { MdOutlinePersonPin } from "react-icons/md";
import PropTypes from "prop-types";

export default function DarkModeIcon(props) {
  const darkMode = props.darkMode || false;
  const childProps = { ...props };
  delete childProps.darkMode;
  return (
    <>{darkMode ? <Brightness7Icon {...childProps} /> : <Brightness4Icon {...childProps} />}</>
  );
}

DarkModeIcon.propTypes = {
  darkMode: PropTypes.bool,
};

export function AddPersonIcon(props) {
  return <PersonAddIcon color="primary" {...props} />;
}
export function ContactIcon(props) {
  return <ContactMailIcon color="primary" {...props} />;
}

export function LoginIcon(props) {
  return <LoginIcon2 {...props} />;
}
export function LogoutIcon(props) {
  return <LogoutIcon2 color="primary" {...props} />;
}

export function PersonIcon(props) {
  return <PersonOutlineIcon {...props} />;
}

export function ProfileIcon(props) {
  return <AccountCircle {...props} />;
}

export function RoleIcon(props) {
  return <MdOutlinePersonPin color="primary" {...props} />;
}
